import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import config from '../../../../../../../config';
import Translate from "../../../../../../../components/Translate";
import DropdownSelect from "../../../../../../../components-new/form/DropdownSelect";
import ColorIndicator from "../../../../../../../components-new/general/ColorIndicator";

const statusesToShow = config.statuses
    .filter(status => status.value !== config.statusMap.pending && status.value !== config.statusMap.deleted)

const statusesToShowTranslated = statusesToShow.map(s => {
    return {
        id: s.id,
        name: s.name,
        value: s.value,
        title: s.title === 'Enabled' ? <Translate text={'ENABLED'}/> : <Translate text={'DISABLED'} />
    };
});

const indicatorColorsMap = {
    [config.statusMap.pending]: '#A4ADC1',
    [config.statusMap.enabled]: '#00E3A6',
    [config.statusMap.disabled]: '#E14E52',
};


const MemberStatus = ({member, updateStatus}) => {

    if (member.status === config.statusMap.pending) {
        return (
            <Fragment>
                <ColorIndicator
                    currentStatus={config.statusMap.pending}
                    indicatorMap={indicatorColorsMap}
                    style={{
                        marginTop: '4px',
                    }}
                />
                <span style={{paddingLeft: '10px', color: '#09183A'}}>
                    <Translate text="PENDING"/>
                </span>
            </Fragment>
        );
    }

    return (
        <DropdownSelect
            overlay
            options={statusesToShowTranslated}
            selectedValue={member.status}
            onChange={(val) => updateStatus(val.value)}
            variant='outline'
            renderIndicator={(value) => (
                <div style={{marginLeft: '10px'}}>
                    <ColorIndicator currentStatus={value} indicatorMap={indicatorColorsMap}/>
                </div>
            )}
            renderLabel={
            (val) => typeof val === 'string' ?
                    <Translate text={val} />
                    :
                    val.title
            }
            styles={{color: 'var(--ds-text-primary)'}}
        >
            {option => (
                <span style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
                    <ColorIndicator currentStatus={option.value} indicatorMap={indicatorColorsMap}/>
                    <span>{option.title}</span>
                </span>
            )}
        </DropdownSelect>
    );
};

MemberStatus.propTypes = {
    member: PropTypes.object.isRequired,
    updateStatus: PropTypes.func.isRequired,
};

export default MemberStatus;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/members/EmployeesTable/partials/MemberStatus.jsx